// import React from "react";
// import PropTypes from "prop-types";
// import { Link,  useLocation} from "react-router-dom";

// const location = useLocation();
// export default function Navbar(props) {
//   return (
//     <>
//     <div>
//       <nav
//         className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
//       >
//         <div className="container-fluid">
//           <Link className="navbar-brand" to="/">
//             {props.title}
//           </Link>
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="navbarSupportedContent">
//             <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//               <li className="nav-item">
//                 <Link 
//   className={`nav-link ${location.pathname === "/" ? "active" : ""}`} 
//   to="/"
// >
//   Home
// </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">
//                   {props.aboutText}
//                 </Link>
//               </li>
//             </ul>
//             {/* <form className="d-flex" role="search">
//         <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" name = "search"/>
//         <button className="btn btn-secondary" type="submit">Search</button>
//       </form> */}
//              <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'} my-2`}>
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 role="switch"
//                 id="flexSwitchCheckDefault"
//                 onClick={props.toggleMode}
//               />
//               <label
//                 className="form-check-label"
//                 htmlFor="flexSwitchCheckDefault"
//               >
//               Enable Dark Mode
//               </label>
//             </div>
//             </div>
//             </div>
//       </nav>
//     </div>
//     </>
//   );
// }

// Navbar.propTypes = {
//   title: PropTypes.string.isRequired,
//   aboutText: PropTypes.string.isRequired,
// };

// Navbar.defaultProps = {
//   title: "Default Title",
//   aboutText: "Default About",
// };

import React from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
      <div className="container-fluid">

        <Link className="navbar-brand" to="/">
          {props.title}
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
          <span 
            className="navbar-toggler-icon"
            style={{ filter: props.mode === "dark" ? "invert(1)" : "invert(0)" }}
          ></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">

          <ul className="navbar-nav me-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                end
                to="/"
              >
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                to="/about"
              >
                {props.aboutText}
              </NavLink>
            </li>

          </ul>

          <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'} my-2`}>
            <input
              className="form-check-input"
              type="checkbox"
              onClick={props.toggleMode}
            />
            <label className="form-check-label">
              {props.mode === "light" ? "Enable Dark Mode" : "Enable Light Mode"}
            </label>
          </div>

        </div>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  aboutText: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  toggleMode: PropTypes.func.isRequired,
};

Navbar.defaultProps = {
  title: "TextUtils",
  aboutText: "About",
};
